import { Box, Divider, Typography } from "@mui/material";
import { useShallow } from "zustand/react/shallow";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import moment from "moment-timezone";

import styles from "../../../assets/styles/componentStyles/billingStyles/billingUsageSideCard.module.scss";

import { useBillingStore } from "../../../store/billingStore";
import { thousandSeparator, formatDateTime } from "../../../utils/constants";
import { getBillingCycleName } from "../utils.billing";
import { CYCLE_TYPES } from "../constant.billing";

const getDaysUntilLabel = (dateValue?: string | null) => {
    if (!dateValue) return null;

    const days = moment(dateValue).startOf("day").diff(moment().startOf("day"), "days");

    if (days < 0) return null;
    if (days === 0) return "Today";
    if (days === 1) return "In 1 day";

    return `In ${days} days`;
};

const UsageNextBillingCard = () => {

    const { billingSubscriptionDetails } = useBillingStore(useShallow((state) => ({
        billingSubscriptionDetails: state.billingSubscriptionDetails,
    })));

    const plan = billingSubscriptionDetails?.current_plan;
    const currencySymbol = plan?.billing_plan_currency_symbol || "₹";
    const billingCycle = plan?.billing_plan_cycle_period_name || CYCLE_TYPES.MONTHLY;
    const cycleName = getBillingCycleName(billingCycle);
    const cycleDisplay = cycleName.charAt(0).toUpperCase() + cycleName.slice(1);

    const invoiceTotal = plan?.razorpay_plan_amount;
    const nextChargeDate = plan?.next_charge_at ? formatDateTime(plan.next_charge_at, "dmTexty") : "—";
    const daysUntilLabel = getDaysUntilLabel(plan?.next_charge_at);

    const recurringAddOns = plan?.recurring_add_ons || [];
    const oneTimeAddOns = plan?.one_time_add_ons || [];
    const hasRecurringAddOns = recurringAddOns.length > 0;
    const hasOneTimeAddOns = oneTimeAddOns.length > 0;

    const invoiceDescription = hasRecurringAddOns
        ? `${cycleDisplay} Renewal • Plan + Recurring Add-ons`
        : hasOneTimeAddOns
            ? `${cycleDisplay} Renewal • Plan + One-time Add-ons`
            : `${cycleDisplay} Renewal • Plan`;

    return (
        <Box className={styles.card}>
            <Box className={styles.dateSection}>
                <Box className={styles.labelGroup}>
                    <Box className={styles.iconWrap}>
                        <EventAvailableOutlinedIcon className={styles.icon} />
                    </Box>

                    <Typography className={styles.sectionLabel}>
                        Next Billing Date
                    </Typography>
                </Box>

                <Typography className={styles.billingDate}>
                    {nextChargeDate}
                </Typography>

                {daysUntilLabel && (
                    <Typography className={styles.daysUntilLabel}>
                        {daysUntilLabel}
                    </Typography>
                )}
            </Box>


            {!!invoiceTotal && invoiceTotal > 0 && (
                <>
                    <Divider className={styles.divider} />

                    <Box className={styles.invoiceSection}>
                        <Typography className={styles.sectionLabel}>
                            Upcoming Invoice
                        </Typography>

                        <Typography className={styles.invoiceAmount}>
                            {currencySymbol}{thousandSeparator(invoiceTotal)}
                        </Typography>

                        <Typography className={styles.invoiceDescription}>
                            {invoiceDescription}
                        </Typography>
                    </Box>
                </>
            )}
        </Box>
    );
};

export default UsageNextBillingCard;
